import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  RESET_LOGIN_FAILURE,
  LOGOUT_SUCCESS,
  REFRESH_TOKEN_SUCCESS,
  UPDATE_USER_DETAILS_SUCCESS,
  UPDATE_USER_BALANCE_SUCCESS,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_AMOUNT_INFO_LIST_SUCCESS,
  UPDATE_USER_DIGITALGAMES_BALANCE_SUCCESS,
  USER_CONTRACT_ACCEPTED,
  ACCEPT_LOTTERY_CONTRACT,
  ACCEPT_SCORE_WARNING,
  EMAIL_VERIFY_SUCCESS,
  UPDATE_PERSONAL_INFORMATIONS_EMAIL_SUCCESS,
  CAPTCHA_REQUIRED,
  DIGITAL_GAMES_POLICY_ACCEPTED,
  DIGITAL_GAMES_VALIDATE_TOKEN,
  PERSONALIZATION_POLICY_UPDATED,
  DIGITAL_GAMES_NEXT_GAME_REQUEST,
  DIGITAL_GAMES_NEXT_GAME_SUCCESS,
  DIGITAL_GAMES_NEXT_GAME_FAILURE,
  DIGITAL_GAMES_CREATE_SESSION,
  UPDATE_IS_EYE_OPEN,
  SEND_RATE_INFORMATION_REQUEST,
  SEND_RATE_INFORMATION_SUCCESS,
  SEND_RATE_INFORMATION_FAILURE,
  DISPLAY_EMAIL_OTP_ACTION_SHEET_IGNORED,
  DISPLAY_SMS_OTP_ACTION_SHEET_IGNORED,
  TRUSTED_DEVICE_ERROR,
  SET_OTP_INFO,
  SET_OTP_ERROR,
  RESET_OTP_ERROR,
  SEND_OTP_ERROR,
  SET_PENDING_MEMBERSHIP,
  CLEAR_PENDING_MEMBERSHIP
} from 'Store/constants';

const initialState = {
  data: {},
  isEyeOpen: null,
  isAuthenticated: null,
  isFetched: false,
  error: null,
  sideMenuOpen: false,
  trustedDeviceError: {},
  otpInfo: {},
  otpError: null,
  sendOtpError: null,
  pendingMembership: {
    isNew: null,
    referenceNumber: null,
    remainingTimeInSeconds: null
  }
};


export default function (state = initialState, action) {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        isFetched: false
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: Object.keys(action.payload).length > 0,
        isFetched: true,
        data: action.payload,
        error: null
      };

    case LOGIN_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        isFetched: true,
        error: action.payload
      };
    case RESET_LOGIN_FAILURE:
      return {
        ...state,
        error: null
      };
   

    case REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        isFetched: true,
        data: {
          ...state.data,
          accessToken: action.payload.accessToken,
          accessTokenExpireDate: action.payload.accessTokenExpireDate
        }
      };

    case UPDATE_USER_DETAILS_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload
        },
        isFetched: true,
        isAuthenticated: true
      };

    case UPDATE_USER_BALANCE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          balance: action.payload
        }
      };

    case UPDATE_USER_AMOUNT_INFO_LIST_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          amountInfoList: action.payload
        }
      };
     
    case UPDATE_USER_DIGITALGAMES_BALANCE_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          digitalGamesBalance: action.payload
        }
      };
      
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          availableTopWinPoint: action.payload
        }
      };

    case LOGOUT_SUCCESS:
      return {
        ...initialState,
        isAuthenticated: false,
        isFetched: true
      };

    case USER_CONTRACT_ACCEPTED:
      return {
        ...state,
        data: {
          ...state.data,
          isApproveLastContract: true
        }
      };

    case ACCEPT_LOTTERY_CONTRACT:
      return {
        ...state,
        data: {
          ...state.data,
          isCommonTicketAgreementAccepted: true
        }
      };

    case ACCEPT_SCORE_WARNING:
      return {
        ...state,
        data: {
          ...state.data,
          bilgilendirici_text_message: true
        }
      };

    case CAPTCHA_REQUIRED: {
      return {
        ...state,
        captchaRequired: true
      };
    }

    case EMAIL_VERIFY_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          isEmailVerificationNeeded: false,
        },
      };
    }

    case UPDATE_PERSONAL_INFORMATIONS_EMAIL_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          isEmailVerificationNeeded: true,
        },
      };
    }

    case DIGITAL_GAMES_POLICY_ACCEPTED:
      return {
        ...state,
        data: {
          ...state.data,
          isAcceptedDigitalGamesPolicy: true
        }
      };

    case DIGITAL_GAMES_VALIDATE_TOKEN:
      return {
        ...state,
        data: {
          ...state.data,
        }
      };

    case PERSONALIZATION_POLICY_UPDATED: {
      const { answer, isError } = action.payload;

      return {
        ...state,
        data: {
          ...state.data,
          isAcceptedPersonalizationPolicy: answer,
          personalizationPolicyDisplay: false,
          personalizationPolicyDisplayDisabledFromClient: isError
        }
      };
    }

    case DIGITAL_GAMES_NEXT_GAME_REQUEST:
      return {
        ...state,
        isFetched: false
      };

    case DIGITAL_GAMES_NEXT_GAME_SUCCESS:
      return {
        ...state,
        isFetched: true,
        data: {
          ...state.data,
        },
        error: null
      };

    case DIGITAL_GAMES_NEXT_GAME_FAILURE:
      return {
        ...state,
        isFetched: true
      };

    case DIGITAL_GAMES_CREATE_SESSION:
      return {
        ...state,
        data: {
          ...state.data,
          digitalGamesSessionId: action.payload
        }
      };

    case UPDATE_IS_EYE_OPEN:
      return {
        ...state,
        isEyeOpen: action.payload
      };

    case SEND_RATE_INFORMATION_REQUEST:
      return { ...state, isLoading: true, error: null };
    case SEND_RATE_INFORMATION_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case SEND_RATE_INFORMATION_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case DISPLAY_EMAIL_OTP_ACTION_SHEET_IGNORED:
      return {
        ...state,
        data: {
          ...state.data,
          displayEmailOtpActionSheet: false
        }
      };

    case DISPLAY_SMS_OTP_ACTION_SHEET_IGNORED:
      return {
        ...state,
        data: {
          ...state.data,
          displaySmsOtpActionSheet: false
        }
      };
    case TRUSTED_DEVICE_ERROR:
      return {
        ...state,
        trustedDeviceError: action.payload
      };

    case SET_OTP_INFO:
      return {
        ...state,
        otpInfo: action.payload
      };
    case SET_OTP_ERROR:
      return {
        ...state,
        otpError: action.payload
      };
    case SEND_OTP_ERROR:
      return {
        ...state,
        sendOtpError: action.payload
      };

    case RESET_OTP_ERROR:
      return {
        ...state,
        otpError: null
      };

    case SET_PENDING_MEMBERSHIP:
      return {
        ...state,
        pendingMembership: {
          isNew: action.payload.isNew,
          referenceNumber: action.payload.referenceNumber,
          remainingTimeInSeconds: action.payload.remainingTimeInSeconds
        }
      };

    case CLEAR_PENDING_MEMBERSHIP:
      return {
        ...state,
        pendingMembership: {
          isNew: null,
          referenceNumber: null,
          remainingTimeInSeconds: null
        }
      };

    default:
      return state;
  }
}
